import { Inject, Injectable } from '@angular/core';
import { ITableState, TableResponseModel, TableService } from '../../../_Core/shared/crud-table';
// import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { baseFilter } from 'src/app/_fake/fake-helpers/http-extenstions';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthModel } from '../../auth/_models/auth.model';
import { AuthService } from '../../auth';
import { HttpHeaders } from '@angular/common/http';
import { TranslationService } from '../../i18n/translation.service';
import { EnvService } from 'src/app/service/env.service';
import { HotToastService } from '@ngneat/hot-toast';


@Injectable({
  providedIn: 'root'
})
export class AppointmentService extends TableService<any> {
  user$: Observable<AuthModel>;
  Token: string = "";
  UserID: number = 0;
  language: any;
  PatientId;
  GuestId;
  API_URL = `${this.environment.apiUrl}/Appointments`;
  constructor(@Inject(HttpClient) http, private spinner: NgxSpinnerService, private translationService: TranslationService,
  private auth: AuthService,private environment : EnvService,private authService: AuthService,private toast: HotToastService) {
    super(http);
    this.user$ = this.auth.currentUserSubject.asObservable();
    this.language = this.translationService.getSelectedLanguage();
    this.user$.subscribe(res => {
      if (res?.userId) {
        if (res.isGuest && res.iqamaId != null && res.iqamaId != '') {
          this.GuestId = res.userId;
          this.PatientId = 0;
        }
        else {
          
          this.PatientId = res.userId;
          this.GuestId = 0;
          
        }
      }
    })
  }

  Header() {
    var UserToken:any = JSON.parse(localStorage.getItem("v1Balsam-authf649ei9a5f55"));
    let header = new HttpHeaders().set("Authorization","Bearer " + UserToken?.token).set("Accept-Language", this.translationService.getSelectedLanguage());
    let UserID = new HttpHeaders().set("UserID", this.UserID.toString());
    const options = {
      headers: header,
      UserID: UserID
    };
    return options;
  }

  // READ
  find(tableState: ITableState): Observable<TableResponseModel<any>> {

    return this.http.post<any[]>(this.API_URL + '/search', tableState, this.Header()).pipe(
      catchError((errorMessage) => {
        
        return of(errorMessage);
      }),
      map((response: any) => {
        if (response.data != null)
        {
          const filteredResult = baseFilter(response, tableState);
          const result: TableResponseModel<any> = {
          items: filteredResult.items,
          total: filteredResult.total
        };
        return result;
        }
        else if (response.error?.status == 401) {
          var refreshToken = JSON.parse(localStorage.getItem("RefreshToken"));
          const RefreshToken = this.authService.RefreshToken(this.PatientId, this.GuestId, refreshToken).subscribe(resl => {
            if (resl.userId && resl.userId != 0 && resl.userId != null) {
              this.patchState(tableState);
            }
            else {
              if (this.language == "ar") {
                this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
              }
              else {
                this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
              }
            }
          });
          this.subscriptions.push(RefreshToken);
        }
        else
        {
          const result: TableResponseModel<any> = {
            items: [],
            total: 0
          };
          return result;
        }
        
      })
    );
  }
 
  ConfirmOrCancelAppointment(AppointmentID: number,AppointmentFlag:number): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/ConfirmOrCancelAppointment?AppointmentID=`+AppointmentID+"&AppointmentFlag="+AppointmentFlag,null,this.Header());
  }
  SaveAppointment(saveAppointmentModel): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/SaveAppointment`,saveAppointmentModel,this.Header());
  }
  
  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }
  showLoader() {
    this.spinner.show();
  }
  hideLoader() {
    this.spinner.hide();
  }
}
